import { httpPc } from '@/utils/httpPc';

export interface CouponListParams {
  pageNo: number;
  pageSize: number;
}

export interface CouponDetailParams {
  coupon_id: string;
}

export interface CouponDetailItem {
  coupon_id: number;
    name: string;
    client_id_str: string;
    deploy_type: string;
    end_date: string;
    grant_num: string;
    grant_type: string;
    is_choose_all: string;
    limit_num: string;
    receive_num: string;
    revoked_at: string;
    start_date: string;
    status: string;
    status_name: string;
    threshold: string;
    threshold_value: string;
    value: string;
    face_value: string;
}

export interface CouponListResp {
  count: number;
  list: Array<CouponDetailItem>,
  page_index: number;
  page_size: string;
}

export enum ThresholdType {
  unlimited = "unlimited", // 无门槛
  fullDown = "fullDown", // 满减
}

export const GoodsScope = {
  all: 'all', // 全部商品
  category: "category", // 指定分类
  brand: "brand", // 指定品牌
}

export const GoodsScopeMap = {
  [GoodsScope.all]: '全部商品',
  [GoodsScope.category]: '指定分类',
  [GoodsScope.brand]: '指定品牌',
}

export const getCouponList = async (params: CouponListParams) => {
  let res = await httpPc.get<AxiosHttpPromise<CouponListResp>>('', { 
    params: {
      module: 'Manager',
      controller: 'BaseCoupon',
      action: 'getCouponList',
      type: 'json',
      ...params
    } 
  });
  return res
};

export const getDetail = async (params: CouponDetailParams) => {
  let res = await httpPc.post<AxiosHttpPromise<CouponDetailItem>>('?module=Manager&controller=BaseCoupon&action=getCouponDetail', params);
  return res
};